import React, { Fragment } from 'react';
import * as CONFIG from './../../constants/Config';
import * as COMMON from './../../constants/Common';

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.handleFrameTasks = this.handleFrameTasks.bind(this);
    }

    componentDidMount() {
        window.addEventListener("message", this.handleFrameTasks);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleFrameTasks);
    }

    handleFrameTasks(e) {
        var data = {};
        //console.log(e.data);
        try {
            data = JSON.parse(e.data);
        } catch (e) {
            //console.log("Error:",e);
            //console.log("Error parsing data from login");
        }
        if (data.token) {
            localStorage.setItem('token', data.token);
            this.setState(this.state);
            // console.log('Login success');
        }
        if (data.token_user) {
            localStorage.setItem('token_user', data.token_user);
        }

        if (data.token_user) {
            let history_location = JSON.parse(sessionStorage.getItem('history_location')); // can be null
            let url = COMMON.BASE_URL;
            if (history_location && history_location.length > 0) {
                url = history_location[history_location.length - 1]; // url before login
            }
            window.location.href = url;
        }
    }
    render() {
        var login = CONFIG.SERVER_IP + "/login";
        return (
            <Fragment>
                <iframe width="100%" frameBorder="0" scrolling="no" height="100%" title="Login" src={login} />
            </Fragment>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/MainPanel/Login.js